import { Injectable } from '@angular/core';

export type BankName =
  | 'Tosee_Saderat'
  | 'Pasargad'
  | 'Shahr'
  | 'Tosee_Taavon'
  | 'Karafarin'
  | 'Dey'
  | 'Resalat'
  | 'Gardeshgari'
  | 'Iran_Zamin'
  | 'Kosar'
  | 'Khavar_Mianeh'
  | 'Tejarat'
  | 'Sepah'
  | 'Refah'
  | 'Saderat'
  | 'Keshavarzi'
  | 'Melli'
  | 'Melall'
  | 'Mehr_Iran'
  | 'Mellat'
  | 'Saman'
  | 'Parsian'
  | 'Ansar'
  | 'Eghtesad_Novin'
  | 'Postbank'
  | 'Sanat_Madan'
  | 'Maskan'
  | 'Tosee'
  | 'Ayandeh'
  | 'Bank_Markazi'
  | 'Hekmat'
  | 'Sina'
  | 'Mehr_Eghtesad'
  | 'Ghavamin'
  | 'Sarmayeh';

@Injectable({
  providedIn: 'root'
})
export class BankService {
  nameToLogo: {
    [key in BankName]: string;
  } = {
    Eghtesad_Novin: 'assets/img/banks/Eghtesad_Novin.svg',
    Ansar: 'assets/img/banks/Ansar.svg',
    Iran_Zamin: 'assets/img/banks/Iran_Zamin.svg',
    Parsian: 'assets/img/banks/Parsian.svg',
    Pasargad: 'assets/img/banks/Pasargad.svg',
    Ayandeh: 'assets/img/banks/Ayandeh.svg',
    Tejarat: 'assets/img/banks/Tejarat.svg',
    Tosee_Taavon: 'assets/img/banks/Tosee_Taavon.svg',
    Tosee_Saderat: 'assets/img/banks/Tosee_Saderat.svg',
    Hekmat: 'assets/img/banks/Hekmat.svg',
    Dey: 'assets/img/banks/dey.svg',
    Refah: 'assets/img/banks/Refah.svg',
    Saman: 'assets/img/banks/Saman.svg',
    Sepah: 'assets/img/banks/Sepah.svg',
    Sarmayeh: 'assets/img/banks/Sarmayeh.svg',
    Sina: 'assets/img/banks/Sina.svg',
    Shahr: 'assets/img/banks/Shahr.svg',
    Saderat: 'assets/img/banks/Saderat.svg',
    Sanat_Madan: 'assets/img/banks/Sanat_Madan.svg',
    Mehr_Iran: 'assets/img/banks/Mehr_Iran.svg',
    Ghavamin: 'assets/img/banks/Ghavamin.svg',
    Karafarin: 'assets/img/banks/Karafarin.svg',
    Keshavarzi: 'assets/img/banks/Keshavarzi.svg',
    Gardeshgari: 'assets/img/banks/Gardeshgari.svg',
    Bank_Markazi: 'assets/img/banks/Bank_Markazi.svg',
    Maskan: 'assets/img/banks/Maskan.svg',
    Mellat: 'assets/img/banks/Mellat.svg',
    Melli: 'assets/img/banks/Melli.svg',
    Mehr_Eghtesad: 'assets/img/banks/Mehr_Eghtesad.svg',
    Postbank: 'assets/img/banks/Postbank.svg',
    Tosee: 'assets/img/banks/Tosee.svg',
    Kosar: 'assets/img/banks/Kosar.svg',
    Melall: 'assets/img/banks/Melall.svg',
    Resalat: 'assets/img/banks/Resalat.svg',
    Khavar_Mianeh: 'assets/img/banks/Khavar_Mianeh.svg'
  };

  cardsToName: {
    [key: number]: BankName;
  } = {
    207177: 'Tosee_Saderat',
    502229: 'Pasargad',
    502806: 'Shahr',
    502908: 'Tosee_Taavon',
    502910: 'Karafarin',
    502938: 'Dey',
    504172: 'Resalat',
    504706: 'Shahr',
    505416: 'Gardeshgari',
    505785: 'Iran_Zamin',
    505801: 'Kosar',
    505809: 'Khavar_Mianeh',
    585983: 'Tejarat',
    589210: 'Sepah',
    589463: 'Refah',
    603769: 'Saderat',
    603770: 'Keshavarzi',
    603799: 'Melli',
    606256: 'Melall',
    606373: 'Mehr_Iran',
    610433: 'Mellat',
    621986: 'Saman',
    622106: 'Parsian',
    627353: 'Tejarat',
    627381: 'Ansar',
    627412: 'Eghtesad_Novin',
    627488: 'Karafarin',
    627648: 'Tosee_Saderat',
    627760: 'Postbank',
    627884: 'Parsian',
    627961: 'Sanat_Madan',
    628023: 'Maskan',
    628157: 'Tosee',
    636214: 'Ayandeh',
    636795: 'Bank_Markazi',
    636949: 'Hekmat',
    639194: 'Parsian',
    639217: 'Keshavarzi',
    639346: 'Sina',
    639347: 'Pasargad',
    639370: 'Mehr_Eghtesad',
    639599: 'Ghavamin',
    639607: 'Sarmayeh',
    991975: 'Mellat'
  };

  idToName: {
    [key: number]: BankName;
  } = {
    55: 'Eghtesad_Novin',
    63: 'Ansar',
    54: 'Parsian',
    57: 'Pasargad',
    18: 'Tejarat',
    22: 'Tosee_Taavon',
    20: 'Tosee_Saderat',
    65: 'Hekmat',
    66: 'Dey',
    13: 'Refah',
    56: 'Saman',
    15: 'Sepah',
    58: 'Sarmayeh',
    59: 'Sina',
    61: 'Shahr',
    19: 'Saderat',
    11: 'Sanat_Madan',
    60: 'Mehr_Iran',
    53: 'Karafarin',
    16: 'Keshavarzi',
    64: 'Gardeshgari',
    10: 'Bank_Markazi',
    14: 'Maskan',
    12: 'Mellat',
    17: 'Melli',
    21: 'Postbank',
    51: 'Tosee',
    62: 'Ayandeh',
    78: 'Khavar_Mianeh',
    70: 'Resalat'
  };

  getBankNameFromCard(card: string): BankName {
    const uniquePart = card.substring(0, 6);
    return this.cardsToName[+uniquePart] ?? this.cardsToName[636795];
  }

  getBankNameFromIban(iban: string): BankName {
    console.log(iban);
    const uniquePart = iban.substring(5, 7);
    return this.idToName[+uniquePart] ?? this.idToName[10];
  }

  getBankLogoAddress(bankName: BankName): string {
    return this.nameToLogo[bankName];
  }

  constructor() {}
}
